import { createSlice } from "@reduxjs/toolkit";
import {
  fetchQuestionHintsTableColumnNames,
  fetchAllQuestionHints,
  createQuestionHints,
  updateQuestionHints,
  deleteQuestionHints,
} from "./thunk";
import { toast } from "react-toastify";

const questionHintsSlice = createSlice({
  name: "QuestionHints",
  initialState: {
    questionHints: [],
    tableColumnNames: [],
    loading: false,
    headerLoad: false,
    error: null,
  },
  reducers: {
    // Add reducers for synchronous actions
    clearQuestionHintsState(state) {
      
      state.questionHints = [];
      state.loading = false;
      state.headerLoad = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch Referral Reward Table Column Names
      .addCase(fetchQuestionHintsTableColumnNames.pending, (state) => {
        state.headerLoad = true;
        state.error = null;
      })
      .addCase(
        fetchQuestionHintsTableColumnNames.fulfilled,
        (state, action) => {
          state.headerLoad = false;
          state.tableColumnNames = action.payload;
        }
      )
      .addCase(fetchQuestionHintsTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Referral Reward
      .addCase(fetchAllQuestionHints.pending, (state) => {
        state.headerLoad = true;
        state.error = null;
      })
      .addCase(fetchAllQuestionHints.fulfilled, (state, action) => {
        state.loading = false;
        state.questionHints = action.payload;
      })
      .addCase(fetchAllQuestionHints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Referral Reward
      .addCase(createQuestionHints.pending, (state) => {
        state.error = null;
      })
      .addCase(createQuestionHints.fulfilled, (state, action) => {
        state.questionHints = [action.payload.data[0], ...state.questionHints];
      })
      .addCase(createQuestionHints.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Referral Reward
      .addCase(updateQuestionHints.pending, (state) => {
        state.error = null;
      })
      .addCase(updateQuestionHints.fulfilled, (state, action) => {
        const index = state.questionHints.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.questionHints[index] = action.payload[0];
        }

      })
      .addCase(updateQuestionHints.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Referral Reward
      .addCase(deleteQuestionHints.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteQuestionHints.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.questionHints = state.questionHints.filter(
          (item) => !deletedIds.includes(item.ID)
        );
      })
      .addCase(deleteQuestionHints.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearQuestionHintsState } = questionHintsSlice.actions; 
export default questionHintsSlice.reducer;
